/**
 * withOrg — stamps org_id onto any insert payload
 * 
 * Usage:
 *   import { withOrg } from '../lib/withOrg'
 * 
 *   const { orgId } = useUser()
 *   await supabase.from('clients').insert(withOrg(form, orgId))
 */

export function withOrg(data, orgId) {
  if (Array.isArray(data)) {
    return data.map(item => ({ ...item, org_id: orgId }))
  }
  return { ...data, org_id: orgId }
}